import {
  getAgreementDigitableLineFromBarCode,
  getCipDigitableLineFromBarCode,
  validateAgreementDigitableLine,
  validateCipDigitableLine,
  isAgreementCode,
} from '../../validator/validateBarcode';

export type DigitableLineDataType = {
  code: string;
  isCip: boolean;
  hasError: boolean;
  errorMessage?: string;
};

const parseBarCode = (barCode: string): DigitableLineDataType => {
  const isCip = barCode.length <= 44 && !isAgreementCode(barCode);

  const getDigitableLineFromBarCode = isCip ? getCipDigitableLineFromBarCode : getAgreementDigitableLineFromBarCode;

  const transformedDigitableLine = getDigitableLineFromBarCode(barCode);

  const validateDigitableLine = isCip ? validateCipDigitableLine : validateAgreementDigitableLine;
  const hasError = validateDigitableLine(transformedDigitableLine);

  return {
    code: hasError ? '' : transformedDigitableLine,
    isCip,
    hasError: Boolean(hasError),
    errorMessage: hasError || undefined,
  };
};

export default parseBarCode;


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/parser/parseBarCode/index.ts